import 'whatwg-fetch';

import { isLocalhost } from './serviceWorker';

const { protocol, hostname } = document.location;

export const API = isLocalhost
  ? `${protocol}//${hostname}${protocol === 'https:' ? ':8443' : ':8080'}/api`
  : '/api';

export const defaultRequestConfig = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: isLocalhost ? 'include' : 'same-origin',
  mode: isLocalhost ? 'cors' : 'same-origin',
  cache: 'default',
};

export const postRequestConfig = {
  ...defaultRequestConfig,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  method: 'POST',
};

export const handleError = (response) => {
  if (response.status < 200 || response.status >= 300) {
    const error = new Error(response.statusText || response.status);
    error.response = response;
    return Promise.reject(error);
  }

  if (response.status === 205) {
    // TODO: cache something in localstorage?
    console.log('Session information expired, reloading!');
    document.location.reload();
  }
  return response;
};

export const getJson = (response) => {
  if (!response.json) {
    const error = new TypeError('No JSON data.');
    error.response = response;
    return Promise.reject(error);
  }
  return response.json();
};
